import { Security, isNonNullable } from '@ipfabric/utils';
import type { RuleNode } from 'components/SecuritySchema/model/SecuritySchemaNode';
import { securitySchemaNodeFromPathLookupOptions } from 'components/SecuritySchema/model/helpers/securitySchemaNodeFromPathLookupOptions';

import {
  type SecurityNodeResolutionScope,
  securitySchemaNodeFromTest,
} from 'components/SecuritySchema/model/helpers/securitySchemaNodeFromTest';

export const securitySchemaNodeFromRule =
  (resolutionScope: SecurityNodeResolutionScope) =>
  (rule: Security.Rule): RuleNode => ({
    action: rule.action,
    active: rule.active,
    children: [
      Security.isActionWithOptions(rule.action)
        ? securitySchemaNodeFromPathLookupOptions(resolutionScope)(
            rule.action.pathLookupOptions,
          )
        : null,
      securitySchemaNodeFromTest(resolutionScope)(rule.test),
    ].filter(isNonNullable),
    ...(rule.cloudPolicy && { cloudPolicy: rule.cloudPolicy }),
    description: rule.description,
    name: rule.name,
    priority: rule.priority,
    type: 'rule',
  });
